export const scrollToElement = (elem, behavior = 'smooth') => {
  elem.scrollIntoView({
    behavior: behavior,
    block: "center"
  });
}